import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import "../style.css";
import { auth, db, logout, deletePostImages } from "../firebase/firebase";
import { GoogleAuthProvider, onAuthStateChanged, signInWithPopup, signOut } from 'firebase/auth';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from "react";
import style from "../styleForm.css";
import nullImage from "../images/nullPP.png";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import { onSnapshot, collection, doc, deleteDoc } from "firebase/firestore";
import logoPPal from "../images/logoNuevoPP.png";




export default function AllyProfile(props) {
  const location = useLocation();
  const itemPass = location.state.userUID;
  const [items, setItems] = useState([]);
  const collectionRef = collection(db, "usersPrincipal");
  const [admin, setAdmin] = useState("none");

  const navigate = useNavigate();

  function doGoUpload() {
    navigate("Upload", { state: { itemPass } });
  };

  async function eliminarExperiencia(item) {
    try {
      // Delete images from storage before deleting the document
      await deletePostImages(item.photo, item.photo2, item.photo3);

      const docRef = doc(db, 'usersPrincipal', item.id);
      await deleteDoc(docRef);
      window.alert("La experiencia ha sido eliminada");

    } catch (err) {
      console.log(err);
    };
  }

  function doExit() {
    navigate(-1);
  };

  function doManage() {
    navigate("/CFSHEBCH7/Admin");
  };

  function refreshPage() {
    window.location.reload(false);
  };

  useEffect(() => {
    console.log(admin)
    const dataTest = onSnapshot(collectionRef, (querySnapshot) => {
      const items = [];
      querySnapshot.forEach((doc) => {
        items.push({ ...doc.data(), id: doc.id });
      });

      if (itemPass === "8b2SM94eisS6EQHS2MTq8WBWdab2") {
        setAdmin("");
        setItems(items);
      } else {
        let itemsFiltrados = items.filter((item) => { return item.user === itemPass; })
        setItems(itemsFiltrados);
      };
    });
    return () => {
      dataTest();
    };
  }, []);

  return (
    <>
      <div className="principalNavbar" >
        <Navbar key="md" expand="md" className="mb-3 text-dark navbarMain">
          <Container fluid>
            <Navbar.Brand className="navbarMain-logo" href="#">
              <img
                src={logoPPal}
                width="100%"
                height="100%"
                className="d-inline-block align-top"
                alt="React Bootstrap logo"
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-md`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-md`}
              aria-labelledby={`offcanvasNavbarLabel-expand-md`}
              placement="end"
            >
              <Offcanvas.Body style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Form className="d-flex">
                  <Button key="ButtonExit" onClick={doExit} className="botonesFn" style={{ margin: "1vw" }}>Volver</Button>
                  <Button key="ButtonGo" onClick={doGoUpload} className="botonesFn" style={{ margin: "1vw" }}>Publicar Experiencia</Button>
                  <Button key="ButtonAd" onClick={doManage} className="botonesFn" style={{ margin: "1vw", display: admin }}>Administrar Postulaciones</Button>
                </Form>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>

        <div className='backgroundWhite'>
          <Row xs={1} md={4} className="g-4 itemsPage">
            {items.map((item) => (
              <div className='ItemsInside'>
                <Col>
                  <Card className={"cards"} key={item.id} onClick={() => { navigate("Modif", { state: { item } }) }}>
                    <Card.Img className={"cardsImageSec"} variant="top" src={item.photo} />
                    <Card.Body className={"cardsBody"}>
                      <Card.Title key={item.title}>{item.title}</Card.Title>
                      <Card.Text style={{ fontSize: 18 }}> Ultima vez actualizado: {item.timeStamp.toDate().toLocaleString()} </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </div>
            ))}
          </Row>
        </div>
      </div>
    </>
  );
}